import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import axios, { AxiosError } from 'axios';

export default () => {
	const { t } = useI18n();

	const errorText = ref(t('globals.errorMessage'));
	const errorTitle = ref(t('globals.error'));

	const getErrorInfo = (error: AxiosError | unknown) => {
		/** Catch certain cases especially in ops */
		if (error === undefined) return;

		if ((error as { message: string }).message === 'canceled') {
			errorTitle.value = 'Canceled';
			errorText.value = 'Request canceled by user';
		} else if (axios.isAxiosError(error)) {
			const { response } = error;
			const data =
				typeof response?.data === 'object'
					? response?.data
					: JSON.parse(response?.data as string);
			const code = response?.status ?? data.code ?? data.statusCode ?? null;
			const message = data.message ?? null;
			const details = data.details ?? null;

			if (code) errorTitle.value = t(`message.status.${code}`);
			if (message) errorText.value = message;

			if (details && details.length)
				errorText.value = `${errorText.value}, ${details[0]?.message}`;
		}
	};

	return { errorText, errorTitle, getErrorInfo };
};
